// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CoordinatesSelectionMap_coordinates-map__pnUZE {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 10000000;
  padding: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media screen and (max-width: 600px) {
  .CoordinatesSelectionMap_coordinates-map__pnUZE {
    margin: 0 0 50px 0;
  }
}
@media screen and (min-width: 600px) {
  .CoordinatesSelectionMap_coordinates-map__pnUZE {
    margin: 0 0 0 80px;
  }
}
@media screen and (max-width: 600px) {
  .CoordinatesSelectionMap_coordinates-map__pnUZE {
    padding: 20px;
  }
}
.CoordinatesSelectionMap_coordinates-map__pnUZE .CoordinatesSelectionMap_container__jhxH- {
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: white;
  box-shadow: var(--shadow);
  border-radius: 5px;
  position: relative;
  max-width: 800px;
  max-height: 800px;
}
.CoordinatesSelectionMap_coordinates-map__pnUZE .CoordinatesSelectionMap_container__jhxH- .CoordinatesSelectionMap_map__cvtqx {
  width: 100%;
  height: 100%;
  cursor: crosshair;
}
.CoordinatesSelectionMap_coordinates-map__pnUZE .CoordinatesSelectionMap_container__jhxH- .CoordinatesSelectionMap_close-button__DSgDY {
  background-color: transparent;
  border: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  position: absolute;
  top: 15px;
  right: 15px;
  border-radius: 50px;
  z-index: 10000000;
  transition: background-color 0.3s ease;
}`, "",{"version":3,"sources":["webpack://./src/Components/CoordinatesSelectionMap/CoordinatesSelectionMap.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,MAAA;EACA,oCAAA;EACA,iBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACI;EAbJ;IAcQ,kBAAA;EAEN;AACF;AAAI;EAjBJ;IAkBQ,kBAAA;EAGN;AACF;AADI;EArBJ;IAsBQ,aAAA;EAIN;AACF;AAFI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAIR;AAFQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAIZ;AADQ;EACI,6BAAA;EACA,YAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,sCAAA;AAGZ","sourcesContent":[".coordinates-map {\n    position: fixed;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    top: 0;\n    background-color: #0003;\n    z-index: 10000000;\n    padding: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media screen and (max-width: 600px) {\n        margin: 0 0 50px 0;\n    }\n\n    @media screen and (min-width: 600px) {\n        margin: 0 0 0 80px;\n    }\n\n    @media screen and (max-width: 600px) {\n        padding: 20px;\n    }\n\n    .container {\n        width: 100%;\n        height: 100%;\n        padding: 10px;\n        background-color: white;\n        box-shadow: var(--shadow);\n        border-radius: 5px;\n        position: relative;\n        max-width: 800px;\n        max-height: 800px;\n\n        .map {\n            width: 100%;\n            height: 100%;\n            cursor: crosshair;\n        }\n\n        .close-button {\n            background-color: transparent;\n            border: none;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            padding: 10px;\n            position: absolute;\n            top: 15px;\n            right: 15px;\n            border-radius: 50px;\n            z-index: 10000000;\n            transition: background-color 0.3s ease;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"coordinates-map": `CoordinatesSelectionMap_coordinates-map__pnUZE`,
	"container": `CoordinatesSelectionMap_container__jhxH-`,
	"map": `CoordinatesSelectionMap_map__cvtqx`,
	"close-button": `CoordinatesSelectionMap_close-button__DSgDY`
};
export default ___CSS_LOADER_EXPORT___;
